import { forwardRef } from "react";
import styles from "./ArticleLayoutSection.module.scss";
import cx from "classnames";

interface Props {
  index?: string;
  introContent?: React.ReactNode;
  sectionedContent: React.ReactNode;
  rightRail: React.ReactNode;
  injectedContent?: React.ReactNode;
}

const ArticleLayoutSection = forwardRef<HTMLDivElement, Props>(
  (
    { index, introContent, sectionedContent, rightRail, injectedContent },
    ref
  ) => {
    return (
      <>
        <div className={styles.root} data-section-index={index} ref={ref}>
          <div className={styles.main}>
            {introContent}
            <div className={styles.sectionsContainer}>{sectionedContent}</div>
          </div>
          <div
            className={cx(styles.rightRail, !introContent && styles.flexRail)}
          >
            {rightRail}
          </div>
        </div>
        {injectedContent}
      </>
    );
  }
);

ArticleLayoutSection.displayName = "ArticleLayoutSection";

export default ArticleLayoutSection;
